import { createSelector } from "reselect";
import _ from "lodash";

export const selectFiles = ({ FileManager_reducer }) => {
    return FileManager_reducer.files;
};
export const getRequesting = ({ FileManager_reducer }) => {
    return FileManager_reducer.requesting;
};
export const selectFolders = ({ FileManager_reducer }) => {
    return FileManager_reducer.folders;
};

export const selectSearchVal = ({ FileManager_reducer }) => {
    return FileManager_reducer.searchVal;
};
export const selectPage = ({ FileManager_reducer }) => {
    return FileManager_reducer.page;
};
export const selectRows = ({ FileManager_reducer }) => {
    return FileManager_reducer.rows;
};

export const selectedFolder = ({ FileManager_reducer }) => {
    return FileManager_reducer.activeFolder;
};
export const selectConfig = ({ MainReducer }) => {
    if (MainReducer.config) return MainReducer.config;
    else return false;
};
export const selectProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) return UserProfile_reducer.profile.profile;
    else return false;
};
export const selectPermissions = createSelector(
    [selectConfig, selectProfile],
    (config = false, { access_level = false }) => {
        if (access_level && config) {
            return config[access_level]["file_manager"];
        } else return false;
    }
);
export const canRead = createSelector([selectPermissions], (config = false) => {
    return config ? config.read : true;
});
export const canUpdate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.update : true;
    }
);
export const canCreate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.create : true;
    }
);
export const canDelete = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.delete : true;
    }
);
export const selectTableData = createSelector(
    [selectFiles, selectedFolder, selectSearchVal],
    (files = false, folder = false, searchVal = "") => {
        if (files) {
            let fileRef = [];
            let fileObj = {};
            if (folder !== "all_files") {
                Object.keys(files).map((e) => {
                    if (e === folder) {
                        Object.values(files[e]).map((f) => {
                            fileObj = {};
                            fileObj["file_id"] = f.file_id;
                            fileObj["file_name"] = f.file_name;
                            fileObj["date_added"] = f.date_added;
                            // fileObj['file_size'] = f.file_size
                            fileObj["file_folder"] = f.file_folder;
                            fileObj["file_url"] = f.file_url;
                            fileObj["file_type"] = f.file_type;
                            fileObj["file_directory"] = f.file_directory;
                            // let file_size = formatBytes(f.file_size, 2);
                            fileObj["file_size"] = f.file_size;
                            fileObj["file_folder"] = e;
                            fileObj["selected"] = f.selected || false;
                            fileObj["flag"] = false;
                            // if (f.file_folder === folder && folder !== "all_files"){
                            // fileRef.push(fileObj)
                            // } else if(folder === "all_files"){
                            //     fileRef.push(fileObj)
                            // }
                            // else return null;
                            fileRef.push(fileObj);
                            return null;
                        });
                    } else return null;
                    return null;
                });
            } else if (folder === "all_files") {
                Object.keys(files).map((e) => {
                    Object.values(files[e]).map((f) => {
                        fileObj = {};
                        fileObj["file_id"] = f.file_id;
                        fileObj["file_name"] = f.file_name;
                        fileObj["date_added"] = f.date_added;
                        // fileObj['file_size'] = f.file_size
                        fileObj["file_folder"] = f.file_folder;
                        fileObj["file_url"] = f.file_url;
                        fileObj["file_type"] = f.file_type;
                        fileObj["file_directory"] = f.file_directory;
                        let file_size = formatBytes(f.file_size, 2);
                        fileObj["file_size"] = file_size;
                        fileObj["file_folder"] = e;
                        fileObj["selected"] = f.selected || false;
                        fileObj["flag"] = true;
                        // if (f.file_folder === folder && folder !== "all_files"){
                        // fileRef.push(fileObj)
                        // } else if(folder === "all_files"){
                        //     fileRef.push(fileObj)
                        // }
                        // else return null;
                        fileRef.push(fileObj);
                        return null;
                    });
                    return null;
                });
            } else {
                return null;
            }
            fileRef = _.compact(fileRef);
            if (searchVal && searchVal !== "") {
                fileRef = _.compact(
                    fileRef.filter((e) => {
                        if (
                            e.file_id
                                .toLowerCase()
                                .includes(searchVal.toLowerCase()) ||
                            e.file_name
                                .toLowerCase()
                                .includes(searchVal.toLowerCase())
                        ) {
                            return e;
                        } else return null;
                    })
                );
            }
            return fileRef.reverse();
        } else {
            return false;
        }
    }
);
// export const selectTableData = createSelector(
//     [selectFiles, selectedFolder, selectSearchVal],
//     (files = false, folder = false, searchVal = "") => {
//         if (files) {
//             let fileInfo = Object.keys(files).map(e => {
//                 let file_id = e;
//                 let file_name = _.get(files[e], "file_name") || "N/A";
//                 let date_added = _.get(files[e], "date_added") || "N/A";
//                 let file_size = _.get(files[e], "file_size") || "N/A";
//                 let file_folder = _.get(files[e], "file_folder") || "N/A";
//                 let file_url = _.get(files[e], "file_url") || "N/A";
//                 let file_type = _.get(files[e], "file_type") || "N/A";
//                 let file_directory = _.get(files[e], "file_directory") || "N/A";
//                 file_size = formatBytes(file_size, 2);
//                 let selected = _.get(files[e], "selected") || false;
//                 if (file_folder === folder && folder !== "all_files")
//                     return {
//                         file_id,
//                         file_name,
//                         date_added,
//                         file_size,
//                         file_folder,
//                         file_url,
//                         file_type,
//                         selected,
//                         file_directory
//                     };
//                 else if (folder === "all_files")
//                     return {
//                         file_id,
//                         file_name,
//                         date_added,
//                         file_size,
//                         file_folder,
//                         file_url,
//                         file_type,
//                         selected,
//                         file_directory
//                     };
//                 else return null;

//             });
//             fileInfo = _.compact(fileInfo);
//             if (searchVal && searchVal !== "") {
//                 fileInfo = _.compact(
//                     fileInfo.filter(e => {
//                         if (
//                             e.file_id
//                                 .toLowerCase()
//                                 .includes(searchVal.toLowerCase()) ||
//                             e.file_name
//                                 .toLowerCase()
//                                 .includes(searchVal.toLowerCase())
//                         ) {
//                             return e;
//                         } else return null;
//                     })
//                 );
//             }
//
//             return fileInfo.reverse();
//         } else return false;
//     }
// );
function formatBytes(a, b) {
    if (0 === a) return "0 Bytes";
    var c = 1024,
        d = b || 2,
        e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
        f = Math.floor(Math.log(a) / Math.log(c));
    return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f];
}
